import CustomScrollbar from './custom-scrollbar';

const selectors = {
  tabLink: '[data-tab-link]',
  tabContent: '[data-tab-content]',
  scrollable: '[data-custom-scrollbar]',
  scrollableHolder: '[data-custom-scrollbar-holder]',
  slider: '[data-slider]',
  tabsContents: '[data-tabs-contents]',
};

const classes = {
  current: 'current',
  hide: 'hide',
  alt: 'alt',
  aosAnimate: 'aos-animate',
  aosInit: 'aos-init',
};

const attributes = {
  tabLink: 'data-tab-link',
  tabContent: 'data-tab-content',
  tabStartIndex: 'data-start-index',
};

const sections = {};

class Tabs {
  constructor(container) {
    this.container = container;
    this.tabsContents = container.querySelector(selectors.tabsContents);
    this.animateElementsTimer = null;

    if (this.container) {
      this.scrollable = this.container.querySelector(`${selectors.scrollable}`);

      this.init();
      this.initCustomScrollbar();
    }
  }

  init() {
    const tabsNavList = this.container.querySelectorAll(selectors.tabLink);
    const firstTabLink = this.container.querySelector(`[${attributes.tabLink}="${this.container.hasAttribute(attributes.tabStartIndex) ? this.container.getAttribute(attributes.tabStartIndex) : 0}"]`);
    const firstTabContent = this.container.querySelector(
      `[${attributes.tabContent}="${this.container.hasAttribute(attributes.tabStartIndex) ? this.container.getAttribute(attributes.tabStartIndex) : 0}"]`
    );

    if (firstTabContent) {
      firstTabContent.classList.add(classes.current);
    }

    if (firstTabLink) {
      firstTabLink.classList.add(classes.current);
    }

    this.checkVisibleTabLinks();

    if (tabsNavList.length) {
      tabsNavList.forEach((element) => {
        const tabId = parseInt(element.getAttribute(attributes.tabLink));
        const tab = this.container.querySelector(`[${attributes.tabContent}="${tabId}"]`);

        element.addEventListener('click', () => {
          this.tabChange(element, tab);
        });

        element.addEventListener('keyup', (event) => {
          if (event.code === theme.keyboardKeys.SPACE || event.code === theme.keyboardKeys.ENTER) {
            this.tabChange(element, tab);
          }
        });
      });
    }
  }

  initCustomScrollbar() {
    if (!this.scrollable) {
      return;
    }

    this.customScrollbar = new CustomScrollbar(this.container);
  }

  tabChange(element, tab) {
    if (element.classList.contains(classes.current)) {
      return;
    }

    const parent = element.closest(selectors.scrollableHolder) ? element.closest(selectors.scrollableHolder) : element.parentElement;
    const parentPadding = parseInt(window.getComputedStyle(parent).getPropertyValue('padding-left'));
    const lastActiveTab = this.container.querySelector(`${selectors.tabContent}.${classes.current}`);
    const lastActiveTabLink = this.container.querySelector(`${selectors.tabLink}.${classes.current}`);
    const slider = tab.querySelector(selectors.slider);

    lastActiveTab.classList.remove(classes.current);
    lastActiveTabLink.classList.remove(classes.current);
    element.classList.add(classes.current);
    tab.classList.add(classes.current);

    // Trigger theme:tab:change custom event to reset the selected tab slider position
    if (slider) {
      slider.dispatchEvent(new CustomEvent('theme:tab:change', {bubbles: false}));
    }

    // Scroll to current tab link
    parent.scrollTo({
      top: 0,
      left: element.offsetLeft - parent.offsetWidth / 2 + element.offsetWidth / 2 + parentPadding,
      behavior: 'smooth',
    });

    element.dispatchEvent(
      new CustomEvent('theme:custom-scrollbar:change', {
        bubbles: true,
        detail: {
          element: element,
        },
      })
    );

    // Trigger animations if they are enabled
    if (theme.settings.animations) {
      this.tabsContents.querySelectorAll(`.${classes.aosInit}`).forEach((element) => {
        element.classList.remove(classes.aosAnimate);
      });

      if (this.animateElementsTimer) {
        clearTimeout(this.animateElementsTimer);
      }

      this.animateElementsTimer = setTimeout(() => {
        tab.querySelectorAll(`.${classes.aosInit}`).forEach((element) => {
          element.classList.add(classes.aosAnimate);
        });
      }, 150);
    }

    if (element.classList.contains(classes.hide)) {
      tab.classList.add(classes.hide);
    }

    this.checkVisibleTabLinks();
  }

  checkVisibleTabLinks() {
    const tabsNavList = this.container.querySelectorAll(selectors.tabLink);
    const tabsNavListHidden = this.container.querySelectorAll(`${selectors.tabLink}.${classes.hide}`);
    const difference = tabsNavList.length - tabsNavListHidden.length;

    if (difference < 2) {
      this.container.classList.add(classes.alt);
    } else {
      this.container.classList.remove(classes.alt);
    }
  }

  onBlockSelect(evt) {
    const element = evt.target;
    if (element) {
      element.dispatchEvent(new Event('click'));

      element.parentNode.scrollTo({
        top: 0,
        left: element.offsetLeft - element.clientWidth,
        behavior: 'smooth',
      });
    }
  }

  onUnload() {
    if (this.customScrollbar) {
      this.customScrollbar.unload();
    }
  }
}

const tabs = {
  onLoad() {
    sections[this.id] = new Tabs(this.container);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
  onUnload() {
    sections[this.id].onUnload();
  },
};

export {tabs};
